<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      form: {
        id_target_peg: null,
        target_peg: "",
        deskripsi: "",
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          this.form = {
            id_target_peg: this.data.id_target_peg,
            target_peg: this.data.target_peg ?? "",
            deskripsi: this.data.deskripsi ?? "",
          };
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {

    resetForm() {
      this.form = {
        id_target_peg: null,
        target_peg: "",
        deskripsi: "",
      };
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.target_peg && this.form.target_peg !== 0) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Target PEG tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      if (isNaN(this.form.target_peg)) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Target PEG harus berupa angka.",
          showConfirmButton: true,
        });
        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION +
            "master-asesmen/target-peg/" +
            this.form.id_target_peg
          : this.BACKEND_URL_VERSION + "master-asesmen/target-peg";

      const method = this.mode === "edit" ? "put" : "post";

      this.isLoading = true;
      axios({
        method,
        url,
        data: this.form,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Target PEG' : 'Tambah Target PEG'"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="Target PEG" class="fw-medium">
        <b-form-input
          v-model="form.target_peg"
          type="number"
          placeholder="Masukkan Target PEG"
        ></b-form-input>
      </b-form-group>

    <div class="mb-3">
        <label for="deskripsi" class="form-label">Deskripsi</label>
        <textarea
          v-model="form.deskripsi"
          class="form-control"
          id="deskripsi"
        ></textarea>
      </div>
     
      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>